import React, { useState, useCallback } from 'react'
import VTODraggableCell from './VTODraggableCell';
import moment from 'moment';
import { useDrop } from 'react-dnd';
import utils from '../../../duck/utils';
import { Mixpanel } from 'helpers/Mixpanel';
import draftLogic from 'pages/ScheduleCalendar/duck/draftLogic';
import constants from 'pages/ScheduleCalendar/constants';

export function VTODroppableCellBox ({ user, date, shiftsForDay, selectedDateToAddShift, selectedShiftToViewDetail, copyVTOToDateDispatch, isCopyingShift, shiftToCopy, moveDraftVTODispatch, allUsers, roles }) {

  const [isHoverButtonVisible, setIsHoverButtonVisible] = useState(false);

  const dropItem = (item) => {
    moveDraftVTODispatch(item, date);
    Mixpanel.track('Moved VTO');
  }

  const mouseEnterCell = (e) => {
    if( isCopyingShift == true  && draftLogic.isVTO(shiftToCopy) == true ){ 
      setIsHoverButtonVisible(true); 
    }else if ( isCopyingShift == false ){
      setIsHoverButtonVisible(true); 
    }
  }

  const mouseExitCell = (e) => {
    setIsHoverButtonVisible(false); 
  }

  const [{canDrop, isOver}, drop] = useDrop(() => ({
    accept: 'VTOCell',

    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }),

    canDrop: (item, monitor) => {
      if( item != null){
        if( false == date.isSame(moment(item.start_at)) || user.owner_id != utils.currentOwnerIdForShift(item) ) {
          return true;
        }
      }
      return false;
    },
  
    drop: (item,monitor) => {
      dropItem(item);
    },

  }), [date, user]
)

  const shiftsCellForDay = useCallback((user, date, shifts, selectedDateToAddShift, selectedShiftToViewDetail, allUsers ) => {

    if (shifts.length > 0) {
      // Sort the shifts by start_at time in descending order
      const sortedShifts = shifts.sort((a, b) => moment(b.start_at).isBefore(moment(a.start_at)));

      return sortedShifts.map(shift => (
        <VTODraggableCell
          key={shift.id}
          user={user}
          date={date}
          shifts={[shift]} // Passing single shift in an array
          handleVTODetail={selectedShiftToViewDetail}
          selectedDateToAddShift={selectedDateToAddShift}
          allUsers = {allUsers}
          allUserShiftsOnDay = {sortedShifts}
          roles={roles}
        />
      ));
    } else {
      return (
        <VTODraggableCell
          user={user}
          date={date}
          handleVTODetail={selectedShiftToViewDetail}
          selectedDateToAddShift={selectedDateToAddShift}
          isCopyingShift={isCopyingShift}
          shiftToCopy={shiftToCopy}
          copyVTOToDateDispatch={copyVTOToDateDispatch}
          roles={roles}
        />
      );
    }
  }, [selectedShiftToViewDetail, copyVTOToDateDispatch, isCopyingShift, shiftToCopy, roles ]);

  const hoverButtonClicked = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if( isCopyingShift == true ){
      copyVTOToDateDispatch(shiftToCopy, date, shiftToCopy.location_id);
    }else{
      selectedDateToAddShift(user, date, constants.ShiftCreationType.VTO);
    }
  }

  const showDottedFrame = (isOver == true && canDrop == true);
  const hoverButtonText = isCopyingShift ? 'Paste VTO' : 'Add';

  return (
    <td className={shiftsForDay.length> 0 ? "shift-row__day-cell top-align" : "shift-row__day-cell middle-align"} ref={drop}  onMouseOverCapture={mouseEnterCell} onMouseLeave={mouseExitCell}>
      {shiftsCellForDay(user, date, shiftsForDay, selectedDateToAddShift, selectedShiftToViewDetail, allUsers )}
      {isHoverButtonVisible && (shiftsForDay.length > 0) && <button className="hover-add" onMouseDownCapture={hoverButtonClicked}>{hoverButtonText}</button>}
      { showDottedFrame && <div className='dotted-drop-frame'></div>}
    </td>
  );
};

export default VTODroppableCellBox; 